import {scriptonload} from '../modules/scriptonload';

var myMap = function (el) {
    var initMap = function(){
            ymaps.ready(createMap);
        },
        Ymap = class {
            constructor(el){
                var param = JSON.parse(el.getAttribute('data-param')),
                    myPlacemark = new ymaps.Placemark([param.lat, param.lon], {}, {
                        iconLayout: 'default#image',
                        iconImageHref: '/static/common/img/symbols/map-icon-big.png',
                        iconImageSize: [45, 48],
                        iconImageOffset: [-17, -48],
                        balloonOffset: [-21, 19]
                    });

                this.myMap = new ymaps.Map(el, {
                    center: [param.lat, param.lon],
                    zoom: 17,
                    controls: ["zoomControl"],
                    behaviors: ['default', 'scrollZoom']
                }, {
                    searchControlProvider: 'yandex#search'
                });
                this.myMap.behaviors.disable(['scrollZoom']);
                this.myMap.geoObjects.add(myPlacemark);
            }
        },
        createMap = function() {
            new Ymap(el); //wdd
        };

    //
    scriptonload(['https://api-maps.yandex.ru/2.1/?lang=ru_RU'], initMap);
};

export {myMap};